import { render, staticRenderFns } from "./pageSidebar.vue?vue&type=template&id=246e1888&scoped=true&"
import script from "./pageSidebar.vue?vue&type=script&lang=js&"
export * from "./pageSidebar.vue?vue&type=script&lang=js&"
import style0 from "./pageSidebar.vue?vue&type=style&index=0&id=246e1888&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246e1888",
  null
  
)

export default component.exports